import { render } from "./clientbillingentry-list.vue?vue&type=template&id=5263bef0"
import script from "./clientbillingentry-list.vue?vue&type=script&lang=js"
export * from "./clientbillingentry-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__